/**
 * Extract 1 or 2 uppercase initials from a user's name or email.
 */
export function getUserInitials(name?: string | null, email?: string | null): string {
  if (name && name.trim()) {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  }
  if (email && email.trim()) {
    return email[0].toUpperCase();
  }
  return 'U';
}

/**
 * Generates a deterministic, vibrant HSL background color based on the user's name or email.
 * Fixed saturation (68%) and lightness (42%) keeps every color equally readable with white text.
 */
export function getUserAvatarColor(name?: string | null, email?: string | null): string {
  const str = (name && name.trim()) || (email && email.trim()) || 'User';
  const hue = [...str].reduce((a, c) => a + c.charCodeAt(0), 0) % 360;
  return `hsl(${hue}, 68%, 42%)`;
}
